var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.realContentbarSource === ""
    ? _c(
        "div",
        [
          _c(
            "MountingPortal",
            {
              attrs: {
                "mount-to": "#responsive-contentbar-container",
                append: "",
              },
            },
            [
              _c("portal-target", {
                attrs: {
                  name: "layout-page",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "portal",
            {
              attrs: {
                to: "layout-page",
              },
            },
            [
              _c(
                "div",
                {
                  ref: "contentbar",
                  staticClass: "contentbar",
                  attrs: {
                    id: "responsive-contentbar",
                  },
                },
                [
                  _vm.hasSidebar
                    ? _c(
                        "div",
                        {
                          ref: "leftNav",
                          staticClass: "contentbar-nav",
                        },
                        [
                          _c(
                            "button",
                            {
                              class: _vm.sidebarIconClasses,
                              attrs: {
                                id: "toggle-sidebar",
                                title: _vm.$gettext("Sidebar öffnen"),
                              },
                              on: {
                                click: function click($event) {
                                  $event.preventDefault()
                                  return _vm.toggleSidebar.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            },
                            [
                              _c("studip-icon", {
                                ref: "sidebarIcon",
                                attrs: {
                                  shape: "sidebar3",
                                  size: 24,
                                  alt: "",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "contentbar-wrapper-left",
                    },
                    [
                      _c("studip-icon", {
                        staticClass: "text-bottom contentbar-icon",
                        attrs: {
                          shape: _vm.icon,
                          size: 24,
                          role: "info",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "nav",
                        {
                          ref: "breadcrumbs",
                          staticClass: "contentbar-breadcrumb",
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.title))])]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    ref: "wrapperRight",
                    staticClass: "contentbar-wrapper-right",
                  }),
                ]
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }